import { useEffect } from "react";
import { useSMSFormState } from "../../SMSForm/hooks";
import { ESMSFormState } from "../../../../../store/slices/smsFormSliceCreator.ts";
import { useB2pOTPMutationReaction } from "./useB2pOTPMutationReaction.ts";
import { limitsQueryConfig } from "../../../../../api";
import { useQuery } from "@tanstack/react-query";

export const SMS_FORM_ERROR_MESSAGES = {
  empty: "Введите код",
  tooShort: "Не менее 4х цифр",
  incorrect: "Неправильный код",
  unexpectedServerError: "Не удалось отправить код, попробуйте ещё раз или зайдите чуть позже.",
};

export function useB2pSMSFormStateReaction() {
  const smsForm = useSMSFormState();
  const limits = useQuery(limitsQueryConfig());
  const firstLimit = limits.data?.[0];
  const verificationMutation = useB2pOTPMutationReaction();

  useEffect(() => {
    switch (smsForm.formState) {
      case ESMSFormState.validating: {
        if (smsForm.code.length === 0) {
          smsForm.setErrorMessage(SMS_FORM_ERROR_MESSAGES.empty);
          smsForm.setFormState(ESMSFormState.initial);
          return;
        }
        if (smsForm.code.length < 4) {
          smsForm.setErrorMessage(SMS_FORM_ERROR_MESSAGES.tooShort);
          smsForm.setFormState(ESMSFormState.initial);
          return;
        }
        smsForm.setFormState(ESMSFormState.validated);
        return;
      }
      case ESMSFormState.validated: {
        if (firstLimit?.id && !verificationMutation.isPending) {
          verificationMutation.mutate({
            limitId: firstLimit.id,
            otp: smsForm.code,
          });
          smsForm.setFormState(ESMSFormState.submitting);
        }
        return;
      }
      case ESMSFormState.submitting:
      case ESMSFormState.submitted: {
        return;
      }
      case ESMSFormState.initial: {
        return;
      }
    }
  }, [smsForm.formState, smsForm.code, firstLimit?.id, verificationMutation.isPending, verificationMutation, smsForm]);
}
